import React, { useState } from 'react';
import { 
  FaStar, 
  FaPhone, 
  FaClock, 
  FaCheck,
  FaUsers,
  FaMapMarkerAlt,
  FaCar,
  FaChevronRight,
  FaHeart,
  FaArrowRight,
  FaCalendarAlt,
  FaRegHeart,
  FaCamera,
  FaRupeeSign
} from 'react-icons/fa';
import { 
  MdTempleHindu,
  MdHistory,
  MdEmojiEvents,
  MdAccessTime,
  MdDirections,
  MdHotel,
  MdDirectionsBoat
} from 'react-icons/md';
import { 
  GiPeaceDove, 
  GiSunrise,
  GiPhotoCamera
} from 'react-icons/gi';
import "../style.css";

const Sightseeing = () => {
  const [favorites, setFavorites] = useState([1]);

  const images = {
    hero: "https://www.magadhtours.com/Dambadiva-Tours/image/Varanasi.jpg",
    temple: "https://www.fabhotels.com/blog/wp-content/uploads/2024/01/d8288a7e-kashi-vishwanath-temple-min.jpg",
    boat: "https://images.unsplash.com/photo-1564507004663-b6dfb3e2ede5?w=400&h=250&fit=crop&crop=center",
    sarnath: "https://static.toiimg.com/photo/68814312/Sarnath.jpg?width=748&resize=4",
    aarti: "https://www.civitatis.com/f/india/varanasi/galeria/ceremonia-aarti-amanecer.jpg",
    sunset: "https://www.pilgrimagetour.in/blog/wp-content/uploads/2023/10/Kashi-Vishwanath-Temple-Timings.jpg",
    ghat: "https://static.toiimg.com/photo/67849874/varanasi-ghat.jpg?width=748&resize=4",
    guide: "https://i.pinimg.com/736x/2a/60/dd/2a60dd24629fd4c31a75e0242e4c8dc4.jpg"
  };

  const tours = [
    {
      id: 1,
      title: "Sunrise Ganga Aarti",
      desc: "Experience divine morning rituals with boat ride",
      icon: <GiSunrise />,
      image: images.aarti,
      color: "#8B5CF6",
      rating: 4.9
    },
    {
      id: 2,
      title: "Temple Heritage Walk",
      desc: "Explore ancient temples with expert guide",
      icon: <MdTempleHindu />,
      image: images.temple,
      color: "#10B981",
      rating: 4.8
    },
    {
      id: 3,
      title: "Sarnath Excursion",
      desc: "Buddhist heritage site with museum visit",
      icon: <GiPeaceDove />,
      image: images.sarnath,
      color: "#F59E0B",
      rating: 4.7
    }
  ];

  const places = [
    {
      id: 1,
      title: "Kashi Vishwanath",
      type: "Golden Temple",
      distance: "2.5 km",
      icon: <MdTempleHindu />,
      image: images.temple,
      color: "#8B5CF6"
    },
    {
      id: 2,
      title: "Ganga Ghats",
      type: "River Front",
      distance: "On River",
      icon: <MdDirectionsBoat />,
      image: images.ghat,
      color: "#3B82F6"
    },
    {
      id: 3,
      title: "Sarnath",
      type: "Buddhist Site",
      distance: "10 km",
      icon: <GiPeaceDove />,
      image: images.sarnath,
      color: "#10B981"
    }
  ];

  const services = [
    { icon: <FaStar />, text: "Premium Service" },
    { icon: <MdHotel />, text: "Hotel Pickup" },
    { icon: <FaUsers />, text: "Expert Guides" },
    { icon: <FaCar />, text: "AC Transport" }
  ];

  return (
    <div className="varanasi-tours">
      {/* Hero Section */}
      <section className="tour-hero">
        <div className="hero-background">
          <img src={images.hero} alt="Varanasi" className="hero-bg" />
          <div className="hero-overlay-dark">
            <div className="container">
              <div className="hero-content">
                <div className="hero-tag">
                  <FaStar />
                  <span>Premium Experience</span>
                </div>
                <h1 className="hero-headline">
                  Discover Varanasi
                  <br />
                  <span className="highlight">Like Never Before</span>
                </h1>
                <p className="hero-description">
                  Expert-guided tours through ancient temples, sacred ghats, and spiritual landmarks
                </p>
                <button className="hero-cta">
                  Explore Tours <FaChevronRight />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <div className="services-grid">
            {services.map((service, idx) => (
              <div key={idx} className="service-item">
                <div className="service-icon">
                  {service.icon}
                </div>
                <span>{service.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Tours Section */}
      <section className="tours-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Curated Tours</h2>
            <p className="section-subtitle">Premium experiences for every traveler</p>
          </div>
          
          <div className="tours-grid">
            {tours.map((tour) => (
              <div key={tour.id} className="tour-card">
                <div className="tour-image">
                  <img src={tour.image} alt={tour.title} />
                  <button 
                    className={`heart-btn ${favorites.includes(tour.id) ? 'active' : ''}`}
                    onClick={() => setFavorites(prev => 
                      prev.includes(tour.id) 
                        ? prev.filter(id => id !== tour.id)
                        : [...prev, tour.id]
                    )}
                  >
                    {favorites.includes(tour.id) ? <FaHeart /> : <FaRegHeart />}
                  </button>
                  <div className="tour-category" style={{ backgroundColor: tour.color }}>
                    {tour.icon}
                  </div>
                  <div className="tour-rating">
                    <FaStar /> {tour.rating}
                  </div>
                </div>
                
                <div className="tour-content">
                  <div className="tour-meta">
                    <h3>{tour.title}</h3>
                    <div className="tour-duration">
                      <FaClock /> {tour.time}
                    </div>
                  </div>
                  
                  <p className="tour-description">{tour.desc}</p>
                  
                  
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Places Section */}
      <section className="places-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Must Visit Places</h2>
            <p className="section-subtitle">Iconic landmarks of spiritual Varanasi</p>
          </div>
          
          <div className="places-grid">
            {places.map((place) => (
              <div key={place.id} className="place-card">
                <div className="place-image">
                  <img src={place.image} alt={place.title} />
                  <div className="place-info">
                    <div className="place-icon" style={{ backgroundColor: place.color }}>
                      {place.icon}
                    </div>
                    <div>
                      <h4>{place.title}</h4>
                      <p>{place.type}</p>
                    </div>
                  </div>
                </div>
                
                <div className="place-details">
                  <div className="place-meta">
                    <span className="place-distance">
                      <FaMapMarkerAlt /> {place.distance}
                    </span>
                    <span className="place-visitors">
                      <FaUsers /> 500+
                    </span>
                  </div>
                  
                  <div className="place-actions">
                    <button className="view-btn">View</button>
                    <button className="direction-btn">
                      <MdDirections />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section with Image */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-card">
            <div className="cta-left">
              <div className="cta-badge">
                <MdEmojiEvents />
                <span>Best Value Deal</span>
              </div>
              
              <h2 className="cta-title">Customize Your Experience</h2>
              <p className="cta-text">
                Share your preferences and we'll create a personalized itinerary 
                with expert guides and comfortable transportation.
              </p>
              
              <div className="cta-buttons">
                <button className="cta-btn primary">
                  <FaCalendarAlt />
                  Plan Your Tour
                </button>
                <button className="cta-btn secondary">
                  <FaPhone />
                  Call: 6307291567
                </button>
              </div>
              
              <div className="cta-services">
                <div className="service">
                  <MdHotel />
                  <span>Hotel Pickup</span>
                </div>
                <div className="service">
                  <FaStar />
                  <span>Expert Guides</span>
                </div>
                <div className="service">
                  <FaCar />
                  <span>AC Transport</span>
                </div>
              </div>
            </div>
            
            <div className="cta-right">
              <img src={images.guide} alt="Tour Guide" />
              <div className="image-tag">
                <GiPhotoCamera />
                <span>Expert Guided Tours</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Sightseeing;